import { render, staticRenderFns } from "./NestedCustomViewNode.vue?vue&type=template&id=63679ea2&"
import script from "./NestedCustomViewNode.vue?vue&type=script&lang=js&"
export * from "./NestedCustomViewNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports